/**
 * Greek city to postal code lookup
 * Contains major cities and their primary postal codes
 */

const GREEK_CITY_POSTAL_CODES = {
  // Athens and Attica
  'athens': '10431',
  'αθήνα': '10431',
  'athina': '10431',
  'piraeus': '18531',
  'πειραιάς': '18531',
  'piraeus': '18531',
  'marousi': '15122',
  'μαρούσι': '15122',
  'kifisia': '14561',
  'κηφισιά': '14561',
  'glyfada': '16675',
  'γλυφάδα': '16675',
  'chalandri': '15232',
  'χαλάνδρι': '15232',
  'nea smyrni': '17121',
  'νέα σμύρνη': '17121',
  'kallithea': '17676',
  'καλλιθέα': '17676',
  'peristeri': '12131',
  'περιστέρι': '12131',
  'ilioupoli': '16345',
  'ηλιούπολη': '16345',
  'neo psychiko': '15451',
  'νέο ψυχικό': '15451',
  'vouliagmeni': '16671',
  'βουλιαγμένη': '16671',

  // Thessaloniki
  'thessaloniki': '54621',
  'θεσσαλονίκη': '54621',
  'kalamaria': '55133',
  'καλαμαριά': '55133',
  'pylaia': '55535',
  'πυλαία': '55535',
  'evosmos': '56224',
  'εύοσμος': '56224',

  // Other major cities
  'patra': '26221',
  'πάτρα': '26221',
  'patras': '26221',
  'larissa': '41221',
  'λάρισα': '41221',
  'heraklion': '71201',
  'ηράκλειο': '71201',
  'volos': '38221',
  'βόλος': '38221',
  'ioannina': '45221',
  'ιωάννινα': '45221',
  'kavala': '65201',
  'καβάλα': '65201',
  'chania': '73131',
  'χανιά': '73131',
  'rhodes': '85100',
  'ρόδος': '85100',
  'alexandroupoli': '68100',
  'αλεξανδρούπολη': '68100',
  'serres': '62121',
  'σέρρες': '62121',
  'trikala': '42131',
  'τρίκαλα': '42131',
  'katerini': '60100',
  'κατερίνη': '60100',
  'lamia': '35100',
  'λαμία': '35100',
  'agrinio': '30100',
  'αγρίνιο': '30100',
  'kalamata': '24100',
  'καλαμάτα': '24100',
  'corfu': '49100',
  'κέρκυρα': '49100',
  'chalkida': '34100',
  'χαλκίδα': '34100',
  'kozani': '50100',
  'κοζάνη': '50100',
  'xanthi': '67100',
  'ξάνθη': '67100',
  'komotini': '69100',
  'κομοτηνή': '69100',
  'drama': '66100',
  'δράμα': '66100',
  'veria': '59100',
  'βέροια': '59100',
  'tripoli': '22100',
  'τρίπολη': '22100',
  'corinth': '20100',
  'κόρινθος': '20100',
  'rethymno': '74100',
  'ρέθυμνο': '74100',
  'agios nikolaos': '72100',
  'άγιος νικόλαος': '72100',
  'mytilene': '81100',
  'μυτιλήνη': '81100',
  'chios': '82100',
  'χίος': '82100',
  'samos': '83100',
  'σάμος': '83100',
  'zakynthos': '29100',
  'ζάκυνθος': '29100',
  'argostoli': '28100',
  'αργοστόλι': '28100',
  'lefkada': '31100',
  'λευκάδα': '31100',
  'nafplio': '21100',
  'ναύπλιο': '21100',
  'sparti': '23100',
  'σπάρτη': '23100',
  'pyrgos': '27100',
  'πύργος': '27100',
  'kilkis': '61100',
  'κιλκίς': '61100',
  'florina': '53100',
  'φλώρινα': '53100',
  'kastoria': '52100',
  'καστοριά': '52100',
  'grevena': '51100',
  'γρεβενά': '51100',
  'edessa': '58200',
  'έδεσσα': '58200',
};

/**
 * Get postal code for a Greek city
 * @param {string} city - City name (in Greek or English)
 * @returns {string|null} - Postal code or null if not found
 */
export const getPostalCodeForCity = (city) => {
  if (!city) return null;

  const normalizedCity = city.toLowerCase().trim();

  // Direct lookup
  if (GREEK_CITY_POSTAL_CODES[normalizedCity]) {
    return GREEK_CITY_POSTAL_CODES[normalizedCity];
  }

  // Partial match - check if city name is contained
  for (const [cityName, postalCode] of Object.entries(GREEK_CITY_POSTAL_CODES)) {
    if (normalizedCity.includes(cityName) || cityName.includes(normalizedCity)) {
      return postalCode;
    }
  }

  return null;
};

/**
 * Get list of Greek cities for autocomplete
 * @returns {Array} - Array of city names
 */
export const getGreekCities = () => {
  // Return unique city names (prefer Greek names)
  const greekCities = new Set();
  for (const city of Object.keys(GREEK_CITY_POSTAL_CODES)) {
    // Only add Greek city names (contain Greek characters)
    if (/[\u0370-\u03ff\u1f00-\u1fff]/.test(city)) {
      greekCities.add(city.charAt(0).toUpperCase() + city.slice(1));
    }
  }
  return Array.from(greekCities).sort();
};

export default GREEK_CITY_POSTAL_CODES;
